var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getConfig } from "@jti/fe-common";
import { getIsEvo, LoyaltyApi, ReferralApi } from "@jti/rest-api";
import { setUser } from "../loyaltyCore";
import { fetchUserLoyaltyProfile } from "./fetchUserLoyaltyProfile";
import { fetchUserPoints } from "./fetchUserPoints";
export const fetchReferralStats = createAsyncThunk("loyaltyCore/fetchReferralStats", (_a) => __awaiter(void 0, [_a], void 0, function* ({ uuid, ciam_token }) {
    const referralApi = ReferralApi.init();
    const [customer, stats] = yield Promise.all([
        referralApi.getCustomer(uuid, ciam_token),
        referralApi.getReferralStats(uuid, ciam_token),
    ]);
    return { code: customer.code, referralStats: stats };
}));
export const fetchUserTierData = createAsyncThunk("loyaltyCore/fetchUserTierData", (_a) => __awaiter(void 0, [_a], void 0, function* ({ uuid, ciam_token }) {
    const loyaltyApi = LoyaltyApi.init();
    const _b = yield loyaltyApi.getUserTierData(uuid, ciam_token), { tier_image_url, tier_name, statusCode: __ } = _b, rest = __rest(_b, ["tier_image_url", "tier_name", "statusCode"]);
    return Object.assign({ name: tier_name, image_url: tier_image_url }, rest);
}));
export const handleUser = createAsyncThunk("loyaltyCore/handleUser", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ user, isLoyaltyActive, isReferralActive }, { dispatch }) {
    dispatch(setUser({
        name: user.first_name,
        surname: user.last_name,
        ciamToken: user.ciam_token,
        uuid: user.uuid,
    }));
    let currentUser = {};
    if (isReferralActive) {
        try {
            const referralStats = yield dispatch(fetchReferralStats({ uuid: user.uuid, ciam_token: user.ciam_token })).unwrap();
            currentUser = referralStats;
        }
        catch (error) {
            console.error("Error fetching referral stats", error);
        }
    }
    if (isLoyaltyActive) {
        try {
            const config = getConfig();
            if (getIsEvo(config.LOYALTY_URL)) {
                yield dispatch(fetchUserLoyaltyProfile({}));
            }
            else {
                const [__, tierData] = yield Promise.all([
                    dispatch(fetchUserPoints({ useLocalCache: true })),
                    dispatch(fetchUserTierData({ uuid: user.uuid, ciam_token: user.ciam_token })).unwrap(),
                ]);
                currentUser = Object.assign(Object.assign({}, currentUser), { tier: tierData });
            }
        }
        catch (error) {
            console.error("Error fetching user points or tier data", error);
        }
    }
    dispatch(setUser(currentUser));
}));
//# sourceMappingURL=handleUser.js.map